import config from './config';
import on from './on';
import status from "./status";
import style from './style';
export default [status,config,on,style];